






































import Button from '@/types/components/Button.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        items: {
            type: Array as PropType<Button[]>,
            default: null,
        },
        icon: {
            type: String,
            default: null
        }
    },
    methods: {
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        onclick(item: Button) {
            //  Check if our item is disabled
            const disabled = item.disabledPopup

            //  If it is, then call our disabledpoup
            if (disabled) return this.disabledPopup()

            //  Else, do our callback
            item.callback()
        }
    }
})
